import React from "react";
import styled from "styled-components";
import data from "./councils.json";

const Council = () => {
  return (
    <Container>
      {data.map((item) => {
        return (
          <CouncilContainer>
            <ProfileImg src={`https://i.ibb.co/${item.image}`} />
            <Name>{item.th}</Name>
            <Name>{item.en}</Name>
            <Position>{item.position}</Position>
          </CouncilContainer>
        );
      })}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  gap: 40px;
  padding: 20px;
  flex-wrap: wrap;
  justify-content: center;
`;

const CouncilContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  width: 100%;
  max-width: 250px;
`;

const ProfileImg = styled.img`
  width: 100%;
  max-width: 200px;
`;

const Name = styled.div`
  font-size: 16px;
  font-weight: bold;
  text-align: center;
`;

const Position = styled.div`
  font-size: 14px;
`;

export default Council;
